import React from "react";
import { observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

import { convertSecondsToTime } from "../../../utils/helper";
import { useAppStore } from "../../../providers/AppStoreProvider";

import "./Chapter.scss";

export const CreateChapter = ({ onClick }) => (
  <div
    role="button"
    className="create-chapter d-flex flex-row align-items-center rounded-10 p-3 mx-2 my-2 text-black-50"
    onClick={onClick}
  >
    <i className="fa-duotone fa-circle-plus fa-lg me-3" />
    Thêm chương
  </div>
);

export const Chapter = observer(({ chapter, index, isOpen, onOpen, onClose }) => {
  const store = useAppStore();

  const editChapterHandler = (e, chapter) => {
    e.stopPropagation();
    store.chapterModal.setMode("edit");
    store.chapterModal.setEntityId(chapter.id);
    store.chapterModal.toggle();
  };

  return (
    <div
      role="button"
      className="chapter d-flex flex-row justify-content-between align-items-start rounded-10 p-3 px-4"
      onClick={isOpen ? onClose : onOpen}
    >
      <div className="me-3">
        <div className="fw-bold lh-sm mb-1">
          Chương {index + 1}: {chapter.name}
        </div>
        <div className="d-flex flex-row fs-7 text-black-50">
          <span
            className="chapter-progress"
            data-done={chapter.progress === chapter.lessons.length}
          >
            {chapter.progress}/{chapter.lessons.length} bài học hoàn thành
          </span>

          <span className="mx-2">|</span>

          <span>{convertSecondsToTime(chapter.duration)}</span>
        </div>
      </div>

      <div className="chapter-actions d-flex flex-row align-items-center">
        {store.hasPermission("update_chapter") && (
          <div
            className="action d-flex rounded text-black-50"
            onClick={(e) => editChapterHandler(e, chapter)}
          >
            <i className="fa-regular fa-pen" />
          </div>
        )}
        <div className="action d-flex rounded text-black-50 ms-2">
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
        </div>
      </div>
    </div>
  );
});
